var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative p-4"},[_c('div',{staticClass:"flex flex-row justify-center my-4"},[_c('div',{staticClass:"text-center text-base",domProps:{"innerHTML":_vm._s(_vm.body)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }